import { useState } from 'react';
import { toast } from 'sonner';
import evaluationOpportunityRequestsApi, {
  type OpportunityRequestCreatedI,
} from 'Api/axios/evaluation-opportunity-requests-api';

const ERROR_409 = 'Ya tienes una solicitud pendiente para esta evaluación';

/**
 * Manages the POST flow for submitting an opportunity request.
 *
 * - Distinguishes 409 (duplicate) and 422 (contextual error) by httpStatus.
 * - Any other error shows a generic toast.
 */
const useRequestOpportunity = (lessonId: string, onSuccess: (request: OpportunityRequestCreatedI) => void) => {
  const [submitting, setSubmitting] = useState(false);
  const [inlineError, setInlineError] = useState<string | null>(null);

  const requestOpportunity = async () => {
    setSubmitting(true);
    setInlineError(null);

    const response = await evaluationOpportunityRequestsApi.create({ lessonId });

    if (response.data) {
      onSuccess(response.data);
    } else if (response.httpStatus === 409) {
      setInlineError(ERROR_409);
    } else if (response.httpStatus === 422) {
      setInlineError(response.error ?? 'Error al procesar la solicitud');
    } else {
      toast.error('Ocurrió un problema al enviar la solicitud. Intenta nuevamente.');
    }

    setSubmitting(false);
  };

  return { submitting, inlineError, requestOpportunity };
};

export default useRequestOpportunity;
